@use "button-tokens" as button;

a.button,
button.button,
web-button > button {
    --box-shadow-offset: #{button.$box-shadow-offset};
    --color-background: #{button.$color-primary-normal-background};
    --color-border: #{button.$color-primary-normal-border};
    --color-text: #{button.$color-primary-normal-text};
    --color-box-shadow: #{button.$color-primary-normal-box-shadow};
    --color-fill: #{button.$color-primary-normal-fill};
    --cursor: #{button.$cursor-default};
    --font-size: #{button.$font-size-large};
    --line-height: #{button.$line-height-large};
    --spacing-padding-block: #{button.$spacing-large-padding-block};
    --spacing-padding-inline: #{button.$spacing-large-padding-inline};
    --display: #{button.$display-inline};
    --icon-start-size: #{button.$icon-size-lg};
    --icon-end-size: #{button.$icon-size-lg};
    --font-family: #{button.$font-family-bold};
    --font-weight: #{button.$font-weight-bold};

    align-items: center;
    background-color: var(--color-background);
    border: #{button.$border-width} #{button.$border-style} var(--color-border);
    border-radius: #{button.$border-radius};
    box-shadow: var(--box-shadow-offset) var(--box-shadow-offset) var(--color-box-shadow);
    color: var(--color-text);
    cursor: var(--cursor);
    display: var(--display);
    fill: var(--color-fill);
    font-family: var(--font-family);
    font-size: var(--font-size);
    font-weight: var(--font-weight);
    gap: #{button.$spacing-gap};
    justify-content: center;
    line-height: var(--line-height);
    padding: var(--spacing-padding-block) var(--spacing-padding-inline);
    text-decoration: none;
    text-align: center;
    transition: all #{button.$duration-transition} ease;
    user-select: none;

    @media (min-width: 576px) {
        --display: #{button.$display-inline};
        width: fit-content;
    }

    &[disabled] {
        &:active {
            transform: none;
        }
    }

    web-icon {
        width: auto;

        &.icon-start {
            --icon-height: var(--icon-start-size);
            --icon-width: var(--icon-start-size);
            justify-content: flex-end;
        }

        &.icon-end {
            --icon-height: var(--icon-end-size);
            --icon-width: var(--icon-end-size);
            justify-content: flex-start;
        }
    }
}

.button.button-primary {
    &:hover,
    &:focus {
        --color-background: #{button.$color-primary-hover-background};
        --color-box-shadow: #{button.$color-primary-hover-box-shadow};
        --color-fill: #{button.$color-primary-hover-fill};
        --color-text: #{button.$color-primary-hover-text};
    }

    &:active {
        --color-background: #{button.$color-primary-active-background};
        --color-box-shadow: #{button.$color-primary-active-box-shadow};
        --color-fill: #{button.$color-primary-active-fill};
        --color-text: #{button.$color-primary-active-text};
        translate: var(--box-shadow-offset) var(--box-shadow-offset);
    }

    &[disabled] {
        --color-background: #{button.$color-primary-disabled-background};
        --color-text: #{button.$color-primary-disabled-text};
        --color-box-shadow: #{button.$color-primary-disabled-box-shadow};
        --color-fill: #{button.$color-primary-disabled-fill};
        --cursor: #{button.$cursor-disabled};
        pointer-events: none;
    }
}

.button.button-secondary {
    --color-background: #{button.$color-secondary-normal-background};
    --color-border: #{button.$color-secondary-normal-border};
    --color-text: #{button.$color-secondary-normal-text};
    --color-box-shadow: #{button.$color-secondary-normal-box-shadow};
    --color-fill: #{button.$color-secondary-normal-fill};

    &:hover,
    &:focus {
        --color-text: #{button.$color-secondary-hover-text};
        --color-fill: #{button.$color-secondary-hover-fill};
    }

    &:active {
        --color-text: #{button.$color-secondary-active-text};
        --color-box-shadow: #{button.$color-secondary-active-box-shadow};
        --color-fill: #{button.$color-secondary-active-fill};
        translate: var(--box-shadow-offset) var(--box-shadow-offset);
    }

    &[disabled] {
        --color-background: #{button.$color-secondary-disabled-background};
        --color-text: #{button.$color-secondary-disabled-text};
        --color-box-shadow: #{button.$color-secondary-disabled-box-shadow};
        --color-fill: #{button.$color-secondary-disabled-fill};
        --cursor: #{button.$cursor-disabled};
    }
}

.button.button-plain {
    --color-background: transparent;
    --color-text: #{button.$color-plain-normal-text};
    --font-family: #{button.$font-family-hand};
    --font-size: #{button.$font-size-xxl};
    --font-weight: #{button.$font-weight-normal};
    --spacing-padding-inline: 0;
    --spacing-padding-block: 0;
    box-shadow: none;
    text-decoration: underline;
}

.button.button-extra-small {
    --font-size: #{button.$font-size-small};
    --icon-start-size: #{button.$icon-size-sm};
    --icon-end-size: #{button.$icon-size-sm};
    --spacing-padding-block: #{button.$spacing-small-padding-block};
    --spacing-padding-inline: #{button.$spacing-small-padding-inline};
}

.button.button-small {
    --font-size: #{button.$font-size-medium};
    --icon-start-size: #{button.$icon-size-md};
    --icon-end-size: #{button.$icon-size-sm};
    --spacing-padding-block: #{button.$spacing-small-padding-block};
    --spacing-padding-inline: #{button.$spacing-small-padding-inline};
}

.button.button-large {
    --font-size: #{button.$font-size-large};
    --icon-start-size: #{button.$icon-size-md};
    --icon-end-size: #{button.$icon-size-md};
    --spacing-padding-block: #{button.$spacing-large-padding-block};
    --spacing-padding-inline: #{button.$spacing-large-padding-inline};
}

.button.button-full-width {
    --display: #{button.$display-block};
    width: auto;
}

web-button button.button.button-full-width {
    width: 100%;
}
